document.addEventListener('DOMContentLoaded', function () {
  const showClosePage = window.closePage?.showClosePage;
  const hasTestingTag = window.closePage?.hasTestingTag;
  const referencePagePath = window.closePage?.referencePagePath;

  if (!showClosePage || hasTestingTag) return;

  // Market/locale root, without its trailing slash ('' on the primary market).
  const root = (window.Shopify?.routes?.root ?? '/').replace(/\/$/, '');

  // referencePagePath is already resolved and market-prefixed by theme.liquid, so it only needs
  // resolving against our own origin: a stray absolute or protocol-relative value can never
  // navigate off-site, and any query/hash is dropped before the comparison below.
  let refPath = '';
  if (referencePagePath) {
    try {
      const resolved = new URL(referencePagePath, window.location.origin);
      if (resolved.origin === window.location.origin) {
        refPath = resolved.pathname;
      }
    } catch {
      // Unusable reference page — fall through to the market root.
    }
  }

  // With no usable reference page, send visitors to the market root rather than leaving them
  // on an arbitrary URL. `|| '/'` keeps the primary market a real path: replace('') would
  // reload the current URL forever.
  const target = refPath.replace(/\/$/, '') || root || '/';
  const current = window.location.pathname.replace(/\/$/, '') || '/';

  if (current === target) return;

  window.location.replace(target + window.location.search + window.location.hash);
});
